import React from "react";

const TablaPaquetesMaterialesInsumos = ({item}) => {
  return (
    <tr className="divide-y divide-slate-700">
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">
      {/* <button
            type="button"
            //onClick={hancleClickEliminar}
            className="inline-block px-6 py-2.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Eliminar 
          </button> */}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PaqCod}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        {item.PaqDes}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PQCantPaq}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.ProEmpCod}</td>
    </tr>
  );
};

export default TablaPaquetesMaterialesInsumos;
